import { MaxNumbersOfSuggestions } from 'constants/suggestion';
import { FiltersParams } from 'types/params';
import { Suggestions, isFilterSuggestion } from '../types';

const getSuggestionsThatStartsWith = (
    suggestions: Suggestions[],
    prefix: string,
    getFilterLabel: (filter: string, params: FiltersParams) => string | void,
) => {
    const suggestionsThatStartsWith = [];

    for (let i = 0; i < suggestions.length; i++) {
        if (suggestionsThatStartsWith.length === MaxNumbersOfSuggestions) {
            break;
        }

        const suggestion = suggestions[i];

        if (!isFilterSuggestion(suggestion)) {
            continue;
        }

        const [[params, code]] = suggestion;

        if (!code) {
            continue;
        }

        const lowerCasePrefix = prefix.toLowerCase();

        const displayName = getFilterLabel(code, params);

        const isStartWith = displayName
            ?.toLowerCase()
            ?.startsWith(lowerCasePrefix);

        if (isStartWith) {
            suggestionsThatStartsWith.push(suggestion);
        }
    }

    return suggestionsThatStartsWith;
};

export default getSuggestionsThatStartsWith;
